import { getQueryMethod, resources, entities, methods, getURLParams } from '../utils';
const { meloAPI } = resources;
const { clients } = entities;
const { POST, PATCH, DELETE } = methods;

const query = getQueryMethod(meloAPI, clients);

const endpoints = {
  createClient: async (businessId, clientData) => {
    return await query('', POST, { businessId, ...clientData });
  },
  getClientsPaginated: async ({ businessId, ...params }) => {
    const queryParams = getURLParams(params);
    return await query(`${businessId}?${queryParams}`);
  },
  getClient: async (businessId, clientId) => {
    return await query(`${businessId}/${clientId}`);
  },
  getAllClients: async (businessId, options = {}) => {
    const params = new URLSearchParams();
    if (options.status) {
      params.append('status', options.status);
    }
    const queryString = params.toString();
    return await query(`${businessId}/by/all${queryString ? `?${queryString}` : ''}`);
  },
  updateClient: async (businessId, supplierId, supplierData) => {
    return await query(`${businessId}/${supplierId}`, PATCH, supplierData);
  },
  deleteClient: async (businessId, clientId) => {
    return await query(`${businessId}/${clientId}`, DELETE);
  },
  uploadClients: async (uploadData) => {
    return await query('mass-upload', POST, uploadData);
  }
};

export default endpoints;
